import axios from "axios";

export default axios.create({
    // baseURL: "http://sales.local/api",
    baseURL: "https://admin.yazdtex.com/api",
    // baseURL: "https://es-server.ir/api",
    headers: {
        "Content-type": "application/json"
    }
});